<div class="min-h-screen bg-[#f4f5f7] font-sans text-copy">
  <app-headerhome></app-headerhome>

  <section class="booking-route-summary bg-[#171923] text-white">
    <div class="booking-route-summary-inner mx-auto flex h-[84px] max-w-[1128px] items-center justify-between gap-4 px-[24px] py-[16px]">
      <div>
        <h1 class="flex items-center gap-2 font-display text-[19px] font-extrabold">
          {{ pickUpInit }}
          <svg class="size-4 text-[#ffc800]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" aria-hidden="true"><path d="M5 12h14M13 5l7 7-7 7"/></svg>
          {{ dropOffInit }}
        </h1>
        <p class="mt-0.5 text-[13px] text-[#9ba0ae]">{{ travelDateInit | date:'EEE, d MMM y' }}</p>
      </div>
      <button
        type="button"
        class="booking-edit-toggle focus-ring inline-flex items-center gap-2 rounded-[9px] px-4 py-2 text-[13.5px] font-bold"
        [class.is-open]="editSearchOpen"
        [attr.aria-expanded]="editSearchOpen"
        aria-controls="edit-search-panel"
        (click)="editSearchOpen = !editSearchOpen">
        {{ editSearchOpen ? 'Close' : 'Edit search' }}
        @if (editSearchOpen) {
          <svg class="size-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="m18 15-6-6-6 6"/></svg>
        }
      </button>
    </div>

    @if (editSearchOpen) {
      <div id="edit-search-panel" class="mx-auto max-w-[1128px] px-[24px] pb-[20px]">
        <form autocomplete="off" novalidate #searchForm="ngForm" (ngSubmit)="submitWebForm(searchForm.value); editSearchOpen = false" class="grid items-end gap-3 rounded-[14px] bg-white p-[16px]" [ngClass]="returning ? 'md:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_minmax(150px,0.8fr)_minmax(150px,0.8fr)_auto]' : 'md:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_minmax(180px,1fr)_auto]'">
          <label class="booking-edit-label grid min-w-0 gap-1.5 text-xs font-bold text-slate-600">From
            <ng-select [items]="data" name="pickup" [(ngModel)]="pickUpInit" [clearable]="false" class="booking-edit-select"></ng-select>
          </label>
          <label class="booking-edit-label grid min-w-0 gap-1.5 text-xs font-bold text-slate-600">To
            <ng-select [items]="data" name="dropoff" [(ngModel)]="dropOffInit" [clearable]="false" class="booking-edit-select"></ng-select>
          </label>
          <label class="booking-edit-label grid min-w-0 gap-1.5 text-xs font-bold text-slate-600">Departure date
            <input type="date" name="traveldate" [(ngModel)]="traveldate" [min]="today | date:'yyyy-MM-dd'" required class="h-[44px] rounded-[10px] border border-line bg-gray-50 px-3 text-sm font-semibold text-ink outline-none focus:border-brand">
          </label>
          @if (returning) {
            <label class="booking-edit-label grid min-w-0 gap-1.5 text-xs font-bold text-slate-600">Return date
              <input type="date" name="returndate" [(ngModel)]="returndate" [min]="traveldate" required class="h-[44px] rounded-[10px] border border-line bg-gray-50 px-3 text-sm font-semibold text-ink outline-none focus:border-brand">
            </label>
          }
          <button type="submit" [disabled]="searchForm.invalid" class="booking-primary-button focus-ring h-[42px] rounded-[10px] bg-brand px-[24px] text-sm font-bold text-brand-contrast disabled:cursor-not-allowed disabled:opacity-50">Update</button>
        </form>
      </div>
    }
  </section>

  <main class="mx-auto max-w-[1080px] px-4 pb-16 pt-[22px] sm:px-6">
    <nav class="mb-[20px] flex min-w-0 items-stretch gap-2 overflow-x-auto" aria-label="Travel date">
      <button type="button" class="booking-date-arrow focus-ring flex w-11 shrink-0 items-center justify-center rounded-xl border border-line bg-white text-slate-500 disabled:text-slate-300" [disabled]="dateStripOffset === 0" (click)="shiftDateStrip(-1)" aria-label="Previous days">
        <svg class="size-[18px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>
      </button>
      <div class="grid min-w-[540px] flex-1 grid-cols-4 gap-2">
        @for (date of resultDateOptions; track date.getTime()) {
          <button type="button" class="booking-date-option focus-ring flex min-h-[70px] flex-col items-center justify-center gap-0.5 rounded-xl border px-2 transition"
            [class.is-selected]="isSelectedResultDate(date)"
            [ngClass]="isSelectedResultDate(date) ? 'border-brand bg-brand text-white shadow-[0_6px_16px_rgba(226,33,29,0.24)]' : 'border-line bg-white text-ink hover:border-brand'"
            (click)="changeDate(date)">
            <span class="text-[11.5px] font-bold" [class.opacity-85]="isSelectedResultDate(date)" [class.text-slate-500]="!isSelectedResultDate(date)">{{ dateStripTag(date) }}</span>
            <strong class="text-base font-extrabold">{{ date | date:'d' }}</strong>
            <span class="text-[11px] font-semibold" [class.opacity-85]="isSelectedResultDate(date)" [class.text-slate-400]="!isSelectedResultDate(date)">{{ date | date:'MMM' }}</span>
          </button>
        }
      </div>
      <button type="button" class="booking-date-arrow focus-ring flex w-11 shrink-0 items-center justify-center rounded-xl border border-line bg-white text-slate-500" (click)="shiftDateStrip(1)" aria-label="Next days">
        <svg class="size-[18px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>
      </button>
    </nav>

    <div class="mb-4 flex items-center justify-between lg:hidden">
      <span class="text-[13.5px] font-semibold text-slate-500">{{ filteredResults.length }} {{ filteredResults.length === 1 ? 'bus' : 'buses' }} available</span>
      <button type="button" class="booking-secondary-button focus-ring inline-flex min-h-10 items-center gap-2 rounded-xl border border-line bg-white px-4 text-sm font-bold text-ink" (click)="filterDrawerOpen = true">
        <svg class="size-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 4h16M7 12h10M10 20h4"/></svg>Filters
      </button>
    </div>

    <div class="grid items-start gap-6 lg:grid-cols-[250px_minmax(0,1fr)]">
      <aside class="booking-filter-panel sticky top-6 hidden rounded-2xl border border-[#efeff2] bg-white px-[12px] pb-[4px] pt-[18px] lg:block">
        <div class="mb-3 flex items-center justify-between px-1.5">
          <h2 class="text-[15px] font-extrabold text-ink">Filters</h2>
          @if (hasActiveResultFilters) {
            <button type="button" class="booking-link-button text-xs font-bold text-brand underline" (click)="clearResultFilters()">Clear</button>
          }
        </div>

        <div class="border-b border-gray-100 pb-3">
          <p class="px-1.5 pb-1 text-[11px] font-extrabold uppercase tracking-[0.05em] text-slate-400">Seat type</p>
          <label class="booking-filter-row">
            <input type="checkbox" [(ngModel)]="standardOnly"><span>Standard</span>
          </label>
          <label class="booking-filter-row">
            <input type="checkbox" [(ngModel)]="businessOnly"><span>Business</span>
          </label>
          <label class="booking-filter-row"><input type="checkbox" [(ngModel)]="vipOnly"><span>VIP</span></label>
        </div>

        <div class="border-b border-gray-100 py-3">
          <p class="px-1.5 pb-1 text-[11px] font-extrabold uppercase tracking-[0.05em] text-slate-400">Departure time</p>
          @for (period of [['morning','Morning (before 12pm)'], ['afternoon','Afternoon (12–5pm)'], ['evening','Evening (after 5pm)']]; track period[0]) {
            <label class="booking-filter-row"><input type="radio" name="departurePeriod" [value]="period[0]" [(ngModel)]="departurePeriod"><span>{{ period[1] }}</span></label>
          }
        </div>

        <div class="border-b border-gray-100 py-3">
          <p class="px-1.5 pb-1 text-[11px] font-extrabold uppercase tracking-[0.05em] text-slate-400">Amenities</p>
          <label class="booking-filter-row">
            <input type="checkbox" [(ngModel)]="wifiOnly"><span>Wi-Fi</span>
            <svg class="ml-auto size-4 text-slate-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M4 9a12 12 0 0 1 16 0M7 12a8 8 0 0 1 10 0m-7 3a3.5 3.5 0 0 1 4 0"/><circle cx="12" cy="18" r=".8" fill="currentColor"/></svg>
          </label>
          <label class="booking-filter-row">
            <input type="checkbox" [(ngModel)]="acOnly"><span>AC</span>
            <svg class="ml-auto size-4 text-sky-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M12 2v20M4.2 6.5l15.6 11M19.8 6.5l-15.6 11M9 4l3 2 3-2M9 20l3-2 3 2M5 9l.2 3L2.5 13.5M19 9l-.2 3 2.7 1.5"/></svg>
          </label>
          <label class="booking-filter-row">
            <input type="checkbox" [(ngModel)]="chargingOnly"><span>Charging</span>
            <svg class="ml-auto size-4 text-amber-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="m13 2-7 12h6l-1 8 7-12h-6l1-8Z"/></svg>
          </label>
        </div>

        <div class="py-3">
          <p class="px-1.5 pb-1 text-[11px] font-extrabold uppercase tracking-[0.05em] text-slate-400">Bus type</p>
          <label class="booking-filter-row">
            <input type="checkbox" [(ngModel)]="expressOnly"><span>Highway / Express</span>
          </label>
        </div>
      </aside>

      <section class="min-w-0" aria-live="polite">
        <p class="hidden text-[13.5px] font-semibold text-slate-500 lg:block" style="margin:0 0 12px!important">{{ filteredResults.length }} {{ filteredResults.length === 1 ? 'bus' : 'buses' }} available</p>
        @if (isResultsLoading) {
          <div class="rounded-2xl border border-line-soft bg-white p-8"><app-results-loader></app-results-loader></div>
        } @else if (!filteredResults.length) {
          <div class="rounded-2xl border border-line-soft bg-white p-8 text-center">
            <app-nobuses></app-nobuses>
            @if (hasActiveResultFilters) {
              <button type="button" class="booking-primary-button mt-4 rounded-[10px] bg-[#171923] px-5 py-3 text-sm font-bold text-white" (click)="clearResultFilters()">Clear all filters</button>
            }
          </div>
        } @else {
          <div class="grid gap-4">
            @for (result of filteredResults; track result.id) {
              <article class="bus-result-card flex flex-col gap-5 rounded-2xl border border-[#efeff2] bg-white p-[20px] shadow-[0_4px_18px_rgba(16,24,40,0.06)] transition hover:-translate-y-0.5 hover:shadow-md md:flex-row md:items-center">
                <div class="flex shrink-0 items-center gap-3 md:w-[88px] md:flex-col md:justify-center md:gap-1.5">
                  @if (config?.self?.logo) {
                    <img class="h-8 w-16 object-contain" [src]="config.self.logo" [alt]="operatorName(result)">
                  } @else {
                    <span class="text-xs font-extrabold text-ink">{{ operatorName(result) }}</span>
                  }
                  @if (result.is_express_travel) {
                    <span class="rounded-full bg-[#e7f6ee] px-2 py-1 text-[10.5px] font-bold text-[#1e8e5a]">Highway bus</span>
                  }
                </div>

                <div class="min-w-0 flex-1">
                  <div class="flex items-center gap-4">
                    <div class="result-time-block min-w-0 shrink-0">
                      <p class="text-[19px] font-extrabold text-ink" style="margin:0!important;line-height:1!important">{{ formatResultTime(result.departure_time) }}</p>
                      <p class="result-travel-date whitespace-nowrap text-[10px] font-semibold text-slate-500">{{ resultDepartureDate(result) }}</p>
                      <p class="truncate text-xs text-slate-500" style="margin:2px 0 0!important;line-height:1.2!important">{{ pickUpInit }}</p>
                    </div>
                    <div class="result-route-connector flex min-w-[120px] flex-1 flex-col items-center">
                      <p class="result-route-label max-w-full truncate text-center text-[10.5px] font-bold uppercase text-slate-600">
                        Route: {{ routeLabel(result) }}
                      </p>
                      <div class="result-route-line flex w-full items-center gap-1.5">
                        <span class="h-px flex-1 bg-line"></span>
                        <svg class="size-3 shrink-0 text-slate-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">
                          <rect x="5" y="4" width="14" height="14" rx="2"></rect>
                          <path d="M5 13h14M8 18v2M16 18v2"></path>
                        </svg>
                        <span class="h-px flex-1 bg-line"></span>
                      </div>
                      <span class="whitespace-nowrap text-[11.5px] text-slate-500">{{ tripDuration(result) }}</span>
                    </div>
                    <div class="result-time-block min-w-0 shrink-0 text-right sm:text-left">
                      <p class="text-[19px] font-extrabold text-ink" style="margin:0!important;line-height:1!important">{{ formatResultTime(result.arrival_time) }}</p>
                      <p class="result-travel-date whitespace-nowrap text-[10px] font-semibold text-slate-500">{{ resultArrivalDate(result) }}</p>
                      <p class="truncate text-xs text-slate-500" style="margin:2px 0 0!important;line-height:1.2!important">{{ dropOffInit }}</p>
                    </div>
                  </div>
                  <div class="result-amenities flex flex-wrap items-center gap-2" style="margin-top:12px!important">
                    @if (result.number_of_available_seats !== undefined) {
                      <span class="rounded-full bg-[#fef6e0] px-2.5 py-1 text-xs font-bold text-[#b45309]">{{ result.number_of_available_seats }} seats left</span>
                    }
                    @for (amenity of result.amenities || []; track $index) {
                      <span class="inline-flex items-center gap-1.5 rounded-full bg-[#f2f3f5] px-2.5 py-1 text-[11.5px] text-slate-500">
                        @switch (amenityKind(amenity)) {
                          @case ('wifi') {
                            <svg class="size-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" aria-hidden="true"><path d="M4 9a12 12 0 0 1 16 0M7 12a8 8 0 0 1 10 0m-7 3a3.5 3.5 0 0 1 4 0"/><circle cx="12" cy="18" r=".8" fill="currentColor"/></svg>
                          }
                          @case ('ac') {
                            <svg class="size-3.5 text-sky-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M12 3v18M4.5 7l15 10M19.5 7l-15 10"/></svg>
                          }
                          @case ('charging') {
                            <svg class="size-3.5 text-amber-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" aria-hidden="true"><path d="m13 2-7 12h6l-1 8 7-12h-6l1-8Z"/></svg>
                          }
                          @default {
                            <svg class="size-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="12" cy="12" r="8"/><path d="M9 12h6"/></svg>
                          }
                        }
                        {{ amenityDisplayLabel(amenity) }}
                      </span>
                    }
                  </div>
                </div>

                <div class="bus-result-cta flex shrink-0 items-center justify-between gap-[12px] border-t border-line-soft pt-[16px] md:w-[220px] md:flex-col md:items-end md:border-0 md:pt-[0px] md:text-right">
                  @if (seatFares(result); as fares) {
                    <div class="flex flex-col items-end gap-1.5" aria-label="Available fares">
                      @for (fare of fares; track fare.seatType) {
                        <p class="flex flex-wrap items-center justify-end gap-x-2 gap-y-1" style="margin:0!important;line-height:1.2!important">
                          <span class="text-[11px] font-semibold uppercase tracking-wide text-slate-500">{{ fare.seatType }}</span>
                          @for (price of fare.prices; track price.currency) {
                            <span class="whitespace-nowrap rounded-md bg-slate-50 px-1.5 py-0.5 text-[13px] font-extrabold text-ink">
                              {{ fareCurrencyLabel(price.currency) }} {{ price.amount | number }}
                            </span>
                          }
                        </p>
                      }
                    </div>
                  }
                  <button type="button" class="booking-primary-button focus-ring whitespace-nowrap rounded-[9px] bg-brand px-[20px] py-[11px] text-[13.5px] font-bold text-brand-contrast" (click)="selectSeats(result)">Select seats</button>
                </div>
              </article>
            }
          </div>
        }
      </section>
    </div>
  </main>
</div>

@if (filterDrawerOpen) {
  <button type="button" class="fixed inset-0 z-80 bg-slate-950/50" aria-label="Close filters" (click)="filterDrawerOpen = false"></button>
  <aside class="fixed inset-x-0 bottom-0 z-90 flex max-h-[88vh] flex-col rounded-t-3xl bg-white shadow-2xl" role="dialog" aria-modal="true" aria-label="Trip filters">
    <div class="flex shrink-0 items-center justify-between border-b border-line-soft px-5 py-4">
      <h2 class="font-display text-lg font-extrabold text-ink">Filter trips</h2>
      <button type="button" class="focus-ring size-10 rounded-full bg-gray-100 text-xl" (click)="filterDrawerOpen = false" aria-label="Close filters">×</button>
    </div>
    <div class="flex-1 overflow-y-auto px-5 py-4">
      <section class="border-b border-line-soft pb-4">
        <p class="mb-3 text-xs font-bold uppercase tracking-wide text-slate-500">Seat type</p>
        <div class="grid grid-cols-3 gap-2">
          <label class="mobile-filter-choice"><input type="checkbox" [(ngModel)]="standardOnly"><span>Standard</span></label>
          <label class="mobile-filter-choice"><input type="checkbox" [(ngModel)]="businessOnly"><span>Business</span></label>
          <label class="mobile-filter-choice"><input type="checkbox" [(ngModel)]="vipOnly"><span>VIP</span></label>
        </div>
      </section>

      <section class="border-b border-line-soft py-4">
        <p class="mb-3 text-xs font-bold uppercase tracking-wide text-slate-500">Departure time</p>
        <div class="grid grid-cols-2 gap-2">
          @for (period of [['all','Any time'], ['morning','Before noon'], ['afternoon','12 pm – 6 pm'], ['evening','After 6 pm']]; track period[0]) {
            <label class="mobile-filter-choice">
              <input type="radio" name="mobileDeparturePeriod" [value]="period[0]" [(ngModel)]="departurePeriod"><span>{{ period[1] }}</span>
            </label>
          }
        </div>
      </section>

      <section class="border-b border-line-soft py-4">
        <p class="mb-3 text-xs font-bold uppercase tracking-wide text-slate-500">Amenities</p>
        <div class="grid grid-cols-3 gap-2">
          <label class="mobile-filter-choice">
            <input type="checkbox" [(ngModel)]="wifiOnly">
            <svg class="size-4 text-slate-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M4 9a12 12 0 0 1 16 0M7 12a8 8 0 0 1 10 0m-7 3a3.5 3.5 0 0 1 4 0"/><circle cx="12" cy="18" r=".8" fill="currentColor"/></svg>
            <span>Wi-Fi</span>
          </label>
          <label class="mobile-filter-choice">
            <input type="checkbox" [(ngModel)]="acOnly">
            <svg class="size-4 text-sky-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M12 2v20M4.2 6.5l15.6 11M19.8 6.5l-15.6 11"/></svg>
            <span>AC</span>
          </label>
          <label class="mobile-filter-choice">
            <input type="checkbox" [(ngModel)]="chargingOnly">
            <svg class="size-4 text-amber-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="m13 2-7 12h6l-1 8 7-12h-6l1-8Z"/></svg>
            <span>Charging</span>
          </label>
        </div>
      </section>

      <section class="pt-4">
        <p class="mb-3 text-xs font-bold uppercase tracking-wide text-slate-500">Bus type</p>
        <label class="mobile-filter-choice is-wide">
          <input type="checkbox" [(ngModel)]="expressOnly"><span>Highway / Express trips only</span>
        </label>
      </section>
    </div>
    <div class="grid shrink-0 grid-cols-[auto_1fr] gap-3 border-t border-line-soft bg-white p-4">
      <button type="button" class="focus-ring min-h-12 rounded-xl border border-line px-4 text-sm font-bold text-ink" (click)="clearResultFilters()">Clear</button>
      <button type="button" class="focus-ring min-h-12 rounded-xl bg-brand px-5 text-sm font-bold text-brand-contrast" (click)="filterDrawerOpen = false">Show {{ filteredResults.length }} trips</button>
    </div>
  </aside>
}

@if (seatDrawerOpen) {
  <button type="button" class="fixed inset-0 z-80 bg-slate-950/55" aria-label="Close seat selection" (click)="seatDrawerOpen = false"></button>
  <aside class="seat-prototype-drawer fixed inset-x-0 bottom-0 z-90 flex max-h-[94vh] flex-col rounded-t-[22px] bg-white shadow-2xl lg:inset-y-0 lg:left-auto lg:h-screen lg:max-h-none lg:w-[480px] lg:rounded-none" role="dialog" aria-modal="true" aria-labelledby="seat-drawer-title">
    <header class="seat-prototype-header flex shrink-0 items-start justify-between border-b border-line-soft px-[24px] py-[18px]">
      <div class="flex min-w-0 items-start gap-4">
        @if (config?.self?.logo) {
          <img class="mt-0.5 h-10 w-[92px] shrink-0 object-contain" [src]="config.self.logo" [alt]="operatorName(selectedBus)">
        }
        <div class="min-w-0">
          <h2 id="seat-drawer-title" class="truncate text-[16px] font-extrabold text-ink">{{ pickUpInit }} → {{ dropOffInit }}</h2>
          <p class="mt-1 truncate text-[12.5px] text-slate-500">
            {{ travelDateInit | date:'EEE, d MMM' }} · {{ formatResultTime(selectedBus?.departure_time) }} → {{ formatResultTime(selectedBus?.arrival_time) }}{{ isOvernightArrival(selectedBus) ? ' (+1 day)' : '' }}
            @if (selectedBus?.is_express_travel) { · Highway bus }
          </p>
          @if (availableSeatCount !== null || selectedBus?.number_of_available_seats !== undefined) {
            <p class="mt-1 text-[12.5px] font-bold text-emerald-600">{{ availableSeatCount ?? selectedBus.number_of_available_seats }} seats remaining</p>
          }
          @if (seatRecoveryMessage) {
            <p class="seat-recovery-message mt-2 text-[12.5px] font-bold" role="status">{{ seatRecoveryMessage }}</p>
          }
        </div>
      </div>
      <button type="button" class="seat-drawer-close focus-ring inline-flex size-9 shrink-0 items-center justify-center rounded-full bg-gray-100 text-xl text-ink" (click)="seatDrawerOpen = false" aria-label="Close seat selection">×</button>
    </header>

    <div class="flex-1 overflow-y-auto px-[24px] py-[18px]">
      @if (dataLoading && !seatErrors) {
        <div class="seat-loading-state flex min-h-[610px] flex-col items-center justify-center text-center" role="status" aria-live="polite">
          <div class="seat-loading-ring" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="4" y="6" width="16" height="11" rx="2"/><path d="M7 17v2m10-2v2M7 13h10"/></svg>
          </div>
          <p class="text-[16px] font-extrabold text-ink">Loading available seats</p>
          <p class="text-[12.5px] text-slate-400">Checking live availability on this bus...</p>
          <div class="seat-loading-skeleton grid grid-cols-[44px_44px_43px_44px_44px] gap-x-[10px] gap-y-[9px]" aria-hidden="true">
            @for (placeholder of [1, 2, 3]; track placeholder) {
              <i></i><i></i><span></span><i></i><i></i>
            }
          </div>
        </div>
      } @else if (seatErrors) {
        <div class="mt-4 rounded-2xl bg-red-50 p-5 text-sm leading-6 text-red-700">Seats for this bus could not be loaded. Please close this panel and choose another trip.</div>
      } @else {
        <div class="seat-bus-shell rounded-[16px] border border-line-soft bg-[#fafafb] px-[22px] pb-[20px] pt-[18px]">
          <div class="seat-cockpit mx-auto">
            <span class="seat-steering" [style.grid-column]="driverColumn" aria-label="Driver position">
              <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" aria-hidden="true">
                <circle cx="24" cy="24" r="17"></circle><circle cx="24" cy="24" r="5"></circle>
                <path d="M24 19V7M19 27 9 34M29 27l10 7"></path>
              </svg>
            </span>
          </div>
          <div class="seat-layout mx-auto grid w-fit gap-y-[9px]">
            @for (row of seatLayoutRows; track $index) {
              <div
                class="seat-layout-row grid items-center gap-x-[9px]"
                [class.has-centre-seat]="row.cells[2]?.kind === 'seat'">
                @for (cell of row.cells; track $index) {
                  @if (cell.kind === 'seat') {
                    <button
                      type="button"
                      class="seat-map-button focus-ring"
                      [class.is-vip]="isVipSeat(cell.seat)"
                      [class.is-business]="isBusinessSeat(cell.seat)"
                      [class.is-selected]="isSeatSelected(cell.seat.id)"
                      [class.is-taken]="isSeatTaken(cell.seat)"
                      [disabled]="!isSeatAvailable(cell.seat)"
                      [attr.aria-label]="'Seat ' + cell.seat.id"
                      [attr.aria-pressed]="isSeatSelected(cell.seat.id)"
                      (click)="toggleSeat(selectedBus, cell.seat)">
                      {{ cell.seat.number || cell.seat.id }}
                    </button>
                  } @else if (cell.kind === 'aisle') {
                    <span class="seat-aisle-space" aria-hidden="true"></span>
                  } @else {
                    <span class="seat-map-empty" aria-hidden="true"></span>
                  }
                }
              </div>
            }
          </div>
        </div>

        <section class="seat-legend" aria-label="Seat types and fares">
          <div class="seat-legend-states">
            <span><i class="seat-legend-state is-standard"></i><small>Available</small></span>
            <span><i class="seat-legend-state is-selected"></i><small>Your seat</small></span>
            <span><i class="seat-legend-state is-taken"></i><small>Occupied</small></span>
            <span><i class="seat-legend-state is-business"></i><small>Business</small></span>
            <span><i class="seat-legend-state is-vip"></i><small>VIP</small></span>
          </div>
          <div class="seat-fare-key">
            <span>{{ seatFareLabel('standard') }}</span>
            <span>{{ seatFareLabel('business') }}</span>
            <span>{{ seatFareLabel('vip') }}</span>
          </div>
        </section>
      }
    </div>

    @if (!dataLoading) {
      <footer class="seat-prototype-footer flex shrink-0 items-center justify-between gap-4 border-t border-line-soft bg-white px-[24px] py-[14px]">
        <div>
          <p class="text-[11.5px] text-slate-500">{{ seatsSelected.length }} seat(s) selected</p>
          <p class="text-[20px] font-extrabold leading-tight text-ink">
            @if (totalFareKSH && totalFareUGX) {
              Ksh {{ totalFareKSH | number }} <span class="text-[13px] font-bold text-slate-400">· UGX {{ totalFareUGX | number }}</span>
            } @else if (totalFareKSH) {
              Ksh {{ totalFareKSH | number }}
            } @else if (totalFareUGX) {
              UGX {{ totalFareUGX | number }}
            } @else {
              Ksh 0
            }
          </p>
        </div>
        <button type="button" class="seat-continue-button focus-ring min-h-[44px] rounded-[11px] px-[22px] text-sm font-bold" [disabled]="!seatsSelected.length" (click)="continueToBoarding()">
          {{ seatsSelected.length ? 'Continue with ' + seatsSelected.length + (seatsSelected.length === 1 ? ' seat' : ' seats') : 'Select seats to continue' }}
        </button>
      </footer>
    }
  </aside>
}

@if (boardingDrawerOpen) {
  <button type="button" class="fixed inset-0 z-80 bg-slate-950/55" aria-label="Close boarding selection" (click)="boardingDrawerOpen = false"></button>
  <aside class="boarding-prototype-drawer fixed inset-x-0 bottom-0 z-90 flex max-h-[94vh] flex-col rounded-t-[22px] bg-white shadow-2xl lg:inset-y-0 lg:left-auto lg:h-screen lg:max-h-none lg:w-[523px] lg:rounded-none" role="dialog" aria-modal="true" aria-labelledby="boarding-title">
    <header class="boarding-prototype-header flex shrink-0 items-start justify-between border-b border-line-soft px-[24px] py-[18px]">
      <div class="flex min-w-0 items-start gap-3">
        <button type="button" class="boarding-header-button focus-ring inline-flex size-9 shrink-0 items-center justify-center rounded-[11px] bg-gray-100 text-xl text-ink" (click)="backToSeats()" aria-label="Back to seat selection">←</button>
        <div class="min-w-0">
          <h2 id="boarding-title" class="truncate text-[16px] font-extrabold text-ink">Boarding &amp; drop-off</h2>
          <p class="mt-1 truncate text-[12.5px] text-slate-500">{{ seatsSelected.length }} {{ seatsSelected.length === 1 ? 'seat' : 'seats' }} · {{ selectedSeatLabels }} · same bus</p>
        </div>
      </div>
      <button type="button" class="boarding-header-button focus-ring inline-flex size-9 shrink-0 items-center justify-center rounded-full bg-gray-100 text-xl text-ink" (click)="boardingDrawerOpen = false" aria-label="Close boarding selection">×</button>
    </header>

    <form [formGroup]="pickupForm" (ngSubmit)="submitForm(selectedBus)" class="flex flex-1 flex-col overflow-hidden">
      <div class="boarding-points flex-1 overflow-y-auto px-[24px] py-[20px]">
        <section aria-labelledby="boarding-points-title">
          <h3 id="boarding-points-title" class="boarding-section-title is-pickup">
            <span>1</span> Boarding point
            <small>{{ boardingPointOptions.length }} {{ boardingPointOptions.length === 1 ? 'option' : 'options' }}</small>
          </h3>
          <div
            class="journey-point-list mt-[10px] grid gap-[8px]"
            [class.has-many-options]="boardingPointOptions.length > 4"
            [attr.tabindex]="boardingPointOptions.length > 4 ? 0 : null"
            aria-label="Available boarding points">
            @for (option of boardingPointOptions; track $index) {
              <button
                type="button"
                class="journey-point-card focus-ring"
                [class.is-selected]="isJourneyPointSelected('pickupLocation', option)"
                (click)="selectJourneyPoint('pickupLocation', option)">
                <span class="journey-point-radio" aria-hidden="true"></span>
                <span class="min-w-0 flex-1 text-left">
                  <strong>{{ pointLabel(option) }}</strong>
                  @if (pointSubtitle(option)) {
                    <small>{{ pointSubtitle(option) }}</small>
                  }
                </span>
                <time>{{ pointTime(option, selectedBus?.departure_time) }}</time>
              </button>
            }
          </div>
          @if (submittedMashPoa && fpickup.pickupLocation.invalid) {
            <p class="mt-1.5 text-xs font-semibold text-red-600">Please select your boarding point.</p>
          }
        </section>

        <section class="mt-[20px]" aria-labelledby="dropoff-points-title">
          <h3 id="dropoff-points-title" class="boarding-section-title is-dropoff">
            <span>2</span> Drop-off point
            <small>{{ dropoffPointOptions.length }} {{ dropoffPointOptions.length === 1 ? 'option' : 'options' }}</small>
          </h3>
          <div
            class="journey-point-list mt-[10px] grid gap-[8px]"
            [class.has-many-options]="dropoffPointOptions.length > 4"
            [attr.tabindex]="dropoffPointOptions.length > 4 ? 0 : null"
            aria-label="Available drop-off points">
            @for (option of dropoffPointOptions; track $index) {
              <button
                type="button"
                class="journey-point-card focus-ring"
                [class.is-selected]="isJourneyPointSelected('dropoffLocation', option)"
                (click)="selectJourneyPoint('dropoffLocation', option)">
                <span class="journey-point-radio" aria-hidden="true"></span>
                <span class="min-w-0 flex-1 text-left">
                  <strong>{{ pointLabel(option) }}</strong>
                  @if (pointSubtitle(option)) {
                    <small>{{ pointSubtitle(option) }}</small>
                  }
                </span>
                <time>≈ {{ pointTime(option, selectedBus?.arrival_time) }}</time>
              </button>
            }
          </div>
          @if (submittedMashPoa && fpickup.dropoffLocation.invalid) {
            <p class="mt-1.5 text-xs font-semibold text-red-600">Please select your drop-off point.</p>
          }
        </section>

        <div class="boarding-arrival-note mt-[16px] flex items-start gap-3 rounded-[12px] border border-amber-300 bg-amber-50 px-[14px] py-[13px] text-[12.5px] leading-[17px] text-amber-800">
          <svg class="mt-0.5 size-4 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="12" cy="12" r="8"/><path d="M12 7v5l3 2"/></svg>
          <span>Please arrive at your pickup point at least 30 minutes before departure.</span>
        </div>
      </div>

      <footer class="boarding-prototype-footer flex shrink-0 items-center justify-between gap-4 border-t border-line-soft bg-white px-[24px] py-[14px]">
        <div>
          <p class="text-[11.5px] text-slate-500">Total ({{ seatsSelected.length }} {{ seatsSelected.length === 1 ? 'seat' : 'seats' }})</p>
          <p class="text-[20px] font-extrabold leading-tight text-ink">
            @if (totalFareKSH && totalFareUGX) {
              Ksh {{ totalFareKSH | number }} <span class="text-[13px] font-bold text-slate-400">· UGX {{ totalFareUGX | number }}</span>
            } @else if (totalFareKSH) {
              Ksh {{ totalFareKSH | number }}
            } @else if (totalFareUGX) {
              UGX {{ totalFareUGX | number }}
            } @else {
              Ksh 0
            }
          </p>
        </div>
        <button type="submit" class="boarding-continue-button focus-ring min-h-[44px] rounded-[11px] px-[22px] text-sm font-bold" [disabled]="!pickupForm.valid">
          {{ pickupForm.valid ? 'Continue' : 'Select both points' }}
        </button>
      </footer>
    </form>
  </aside>
}
